import SheetContainer, { Content, Sheet, Overlay } from '../../../mobile/structural/sheet';
import { SheetId } from '../../../mobile/structural/sheet/sheetTypes';
import React from 'react';
import useSheet from '../../../mobile/structural/sheet/hooks/useSheet';
import Icon from '../../icons/Icon';
import { ErrorNoticeContent } from '../errorComponents/getErrorNoticeContent';

import './MobileErrorSheet.scss';

type Props = {
    boardId: string;
    errorNoticeData: object | undefined;
    errorNoticeContent: ErrorNoticeContent | undefined;
    close: () => void;
};

const MobileErrorSheetContent: React.FC<Props> = ({ boardId, errorNoticeContent, errorNoticeData, close }) => {
    const ErrorNoticeContentComponent = errorNoticeContent?.component;

    if (!ErrorNoticeContentComponent) return null;

    return (
        <>
            <div className="logo">
                <Icon name="error-alert" />
            </div>
            <ErrorNoticeContentComponent {...errorNoticeData} errorNoticeData={errorNoticeData} close={close} />
        </>
    );
};

const MobileErrorSheet: React.FC<Props> = (props) => {
    const { close } = props;

    const sheetProps = useSheet(SheetId.Error);

    return (
        <SheetContainer className="MobileErrorSheet" onCloseTransitionEnd={close} {...sheetProps}>
            <Overlay />
            <Sheet>
                <Content>
                    <div className="mobile-error-sheet-container StyledPageContent">
                        <MobileErrorSheetContent {...props} />
                    </div>
                </Content>
            </Sheet>
        </SheetContainer>
    );
};

export default MobileErrorSheet;
